module.exports = __webpack_public_path__ + "static/media/scca-runoffs-2022.cb7e0ed8.jpg";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs-2022.jpg
// module id = 1154
// module chunks = 0